import { Bullet, Localized, LocalizedPlain } from '@synergy/components';
import { LocalizedString } from '@synergy/models';

import { DemandAccountItem } from '../../../../../models/demand-account-item';
import { SectionHeader } from './section-header';

interface FeedbackDetailDemandItemHeaderProps {
    demandItem: DemandAccountItem;
}

const Content = ({ name, description }: { name: LocalizedString; description?: LocalizedString }) => {
    if (description) {
        return (
            <>
                <Localized value={name} />
                <Bullet />
                <LocalizedPlain value={description} />
            </>
        );
    }
    return <Localized value={name} />;
};

export const FeedbackDetailDemandItemHeader = (props: FeedbackDetailDemandItemHeaderProps) => {
    const { demandItem } = props;
    const description = demandItem.longDescription ?? demandItem.shortDescription ?? undefined;

    return (
        <SectionHeader>
            <Content name={demandItem.name} description={description} />
        </SectionHeader>
    );
};
